let nslToken = '';

/**
 * Sets nslToken for use in methods requiring NSL tokens.
 * Should be set anytime a new NSL token is fetched.
 * @param token NSL token string
 */
export function setNslToken(token: string) {
  nslToken = token;
}

/**
 * Returns the nsl token
 * @returns Nsl token
 */
export function getNslToken() {
  return nslToken;
}
